
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2A2ZL", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $f29b64522dc0a459$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $01JF1 = parcelRequire("01JF1");

var $hOqV7 = parcelRequire("hOqV7");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $200NX = parcelRequire("200NX");

var $kNCWT = parcelRequire("kNCWT");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $1FD73 = parcelRequire("1FD73");

var $6wlNh = parcelRequire("6wlNh");

var $k2OeR = parcelRequire("k2OeR");

var $9uFWm = parcelRequire("9uFWm");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-7aebfab68a";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $f29b64522dc0a459$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    (0, $k2OeR.isPerformanceOnetrustEnabled)() && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $200NX.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $kNCWT.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $1FD73.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $hOqV7.loadQuery)(relayEnvironment, query, queryVars);
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hOqV7.RelayEnvironmentProvider), {
                    environment: relayEnvironment,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        pureClientMode: true,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        subAnchor: window.subAnchor,
                        auxiaResponse: window.auxiaResponse,
                        queryRef: queryRef,
                        userAgent: window.navigator.userAgent,
                        children: Component
                    })
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hOqV7.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    mlTemplateIds: window.mlTemplateIds,
                    keyword: window.keyword,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    queryRef: queryRef,
                    children: Component
                })
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("200NX", function(module, exports) {

$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $52ea49f8e16543b5$export$7b31a9938ec3ba75; });
const $52ea49f8e16543b5$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("1FD73", function(module, exports) {

$parcel$export(module.exports, "initRelayEnvironment", function () { return $7d9774703a666878$export$1456be3de97c862f; });

var $4PJsz = parcelRequire("4PJsz");
(0, $4PJsz.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $7d9774703a666878$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride ?? $7d9774703a666878$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $4PJsz.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $4PJsz.Network).create(fetchResponse);
    const store = new (0, $4PJsz.Store)(new (0, $4PJsz.RecordSource)(initialRecords));
    return new (0, $4PJsz.Environment)({
        network: network,
        store: store
    });
}
let $7d9774703a666878$var$clientSideRelayEnvironment;
function $7d9774703a666878$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $7d9774703a666878$var$clientSideRelayEnvironment ?? $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$7d9774703a666878$var$clientSideRelayEnvironment) $7d9774703a666878$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $4PJsz.RecordSource)(initialRecords));
    return $7d9774703a666878$var$clientSideRelayEnvironment;
}

});


parcelRegister("bRUWA", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPage", function () { return $746575e74cc56906$export$ed4c86e3dbd647b; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hCxil = parcelRequire("hCxil");

var $gAJUc = parcelRequire("gAJUc");
const $746575e74cc56906$export$ed4c86e3dbd647b = ({ queryRef: queryRef })=>{
    (0, $iSvIT.useEffect)(()=>{
        (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).cpapiwdConfluenceTemplateDetails);
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hCxil.ConfluenceTemplateDetailsRelayPageTemplate), {
        queryRef: queryRef
    });
};

});
parcelRegister("hCxil", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPageQuery", function () { return $0c7707a7d12c4d73$export$690b2909d81a5261; });
$parcel$export(module.exports, "getConfluenceTemplateDetailsRelayPageQueryVars", function () { return $0c7707a7d12c4d73$export$55ab657411300858; });
$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPageTemplate", function () { return $0c7707a7d12c4d73$export$ee61b52ae9fd1251; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $cunfD = parcelRequire("cunfD");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $4ktyF = parcelRequire("4ktyF");

var $lHB9W = parcelRequire("lHB9W");

var $cRwVc = parcelRequire("cRwVc");

var $3FBn4 = parcelRequire("3FBn4");

var $ltdFC = parcelRequire("ltdFC");

var $lb9n2 = parcelRequire("lb9n2");

var $1MbAx = parcelRequire("1MbAx");

var $lGc56 = parcelRequire("lGc56");

var $lGc56 = parcelRequire("lGc56");

var $a8pnN = parcelRequire("a8pnN");

var $2IcHK = parcelRequire("2IcHK");

var $9iewL = parcelRequire("9iewL");

var $ib2Qr = parcelRequire("ib2Qr");

var $9aBob = parcelRequire("9aBob");
var $0c7707a7d12c4d73$var$_confluenceTemplateDetailsRelayPageQuery;
const $0c7707a7d12c4d73$var$detailPageStyles = null;
const $0c7707a7d12c4d73$var$detailPageContentStyles = null;
const $0c7707a7d12c4d73$var$backLinkStyles = null;
const $0c7707a7d12c4d73$var$backLinkStylesCfind3646 = null;
const $0c7707a7d12c4d73$var$leftSectionStyles = null;
const $0c7707a7d12c4d73$var$rightSectionStyles = null;
const $0c7707a7d12c4d73$var$rightSectionStylesCfind3646 = null;
const $0c7707a7d12c4d73$var$parseTemplateUrlSlug = (pathname)=>{
    const [urlSlug, maybeTemplatesSlug] = pathname.split("/").reverse();
    return urlSlug && maybeTemplatesSlug === "templates" ? urlSlug : "";
};

const $0c7707a7d12c4d73$export$690b2909d81a5261 = $0c7707a7d12c4d73$var$_confluenceTemplateDetailsRelayPageQuery !== void 0 ? $0c7707a7d12c4d73$var$_confluenceTemplateDetailsRelayPageQuery : ($0c7707a7d12c4d73$var$_confluenceTemplateDetailsRelayPageQuery = (parcelRequire("9PXzP")), $0c7707a7d12c4d73$var$_confluenceTemplateDetailsRelayPageQuery.hash && $0c7707a7d12c4d73$var$_confluenceTemplateDetailsRelayPageQuery.hash !== "978aa2c3ffdfcc73a88a375ca658ddbf" && console.error("The definition of 'confluenceTemplateDetailsRelayPageQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $0c7707a7d12c4d73$var$_confluenceTemplateDetailsRelayPageQuery);
const $0c7707a7d12c4d73$export$55ab657411300858 = (location, partialVars)=>{
    const locale = partialVars?.locale ?? (0, $a8pnN.parseQueryLocale)(location);
    const urlSlug = partialVars?.urlSlug ?? $0c7707a7d12c4d73$var$parseTemplateUrlSlug(location.pathname);
    return {
        locale: locale,
        urlSlug: urlSlug
    };
};
const $0c7707a7d12c4d73$var$DetailPageContentRelay = ({ queryRef: queryRef, isCfind3646Treatment: isCfind3646Treatment })=>{
    const { templates: templates } = (0, $hOqV7.usePreloadedQuery)($0c7707a7d12c4d73$export$690b2909d81a5261, queryRef);
    const template = (0, $lHB9W.expectContent)(templates.edges[0]?.node);
    const { setTemplate: setTemplate } = (0, $lGc56.useConfluenceTemplateExperimentContext)();
    const intl = (0, $f6qj2.default)();
    const templatesLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/templates");
    const linkText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.backLink.cfind.1508",
        defaultMessage: "Explore all Confluence templates"
    });
    const backAriaLabel = (0, $1XyNv.ConfluenceTemplateMessages).searchBackAriaLabel.defaultMessage;
    (0, $iSvIT.useEffect)(()=>{
        if (template) {
            const templateName = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).templateTitle, {
                templateName: template.name ?? ""
            });
            setTemplate({
                templateNameExternal: templateName,
                pluginModuleKey: template?.pluginModuleKey
            });
        }
    }, [
        template,
        setTemplate
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "confluence-template-details-page",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _1bah1h6o _2lx21bp4 _4cvr1h6o _bozg7vkz _y4ti7vkz"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _zulpd6z3 _1bah1h6o _p12f1osq _1upz1bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _1bsb1feq _1q5188uy _1pfhj6h1 _4t3i1osq _152tidpf _m3tx1wug _ts4a7vkz _nzln7vkz _hmd4h2mm _pg9o1osq _135a1if8"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    isCfind3646Treatment ? "_syaz17la _1wyb7vkz _k48p1nn1 _1dyz131x _p12f6ecz _ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _1bsb1osq" : "_syaz9sh9 _1wyb7vkz _k48pbfng _1dyz1tnw _p12f6ecz _ca0q8vuz _u5f3idpf _n3td8vuz _19bvidpf _1bsb1osq"
                                ]),
                                style: {
                                    "--_1r6llbg": (0, $43MIc.default)((0, $cRwVc.default)("color.primary.blue"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                                    href: templatesLink,
                                    "aria-label": backAriaLabel,
                                    ...(0, $5VuC0.ConfluenceTemplateAnalytics).searchBackButton(),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $cunfD.LeftArrowIcon), {
                                            size: "13"
                                        }),
                                        linkText
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ib2Qr.TemplateHeaderSection), {
                                template: template,
                                isCfind3646Treatment: isCfind3646Treatment
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9aBob.TemplateKeyFeaturesSection), {
                                template: template,
                                isCfind3646Treatment: isCfind3646Treatment
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2IcHK.TemplateCategorySection), {
                                template: template,
                                isCfind3646Treatment: isCfind3646Treatment
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "TemplateDetailsBody-top",
                        className: (0, $esG4f.default)([
                            isCfind3646Treatment ? "_1e0c1txw _2lx21bp4 _1q518vuz _1bsborz4 _v7367vkz _chtu7vkz _1u2qidpf _1rfm1osq" : "_1e0c1txw _2lx21bp4 _ca0qbv7e _1bsborz4 _ts4a7vkz _nzln7vkz _v40vidpf _pg9o1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9iewL.TemplateDetailsSection), {
                            template: template,
                            isCfind3646Treatment: isCfind3646Treatment
                        })
                    })
                ]
            })
        })
    });
};
const $0c7707a7d12c4d73$export$d11f6c32a9aaae4d = ({ queryRef: queryRef })=>{
    const CFIND3646EmbeddedSignup = (0, $lb9n2.useExperiment)((0, $ltdFC.experiments).cfind3646TemplateDetailseEmbeddedSignup);
    const isCfind3646Treatment = CFIND3646EmbeddedSignup.type === "enrolled" && CFIND3646EmbeddedSignup.value;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lGc56.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($0c7707a7d12c4d73$var$DetailPageContentRelay, {
                    queryRef: queryRef,
                    isCfind3646Treatment: isCfind3646Treatment
                })
            })
        })
    });
};
const $0c7707a7d12c4d73$export$ee61b52ae9fd1251 = (0, $1MbAx.withFeatureExposed)("template-details-page-template-details-seo-v2", "enrolled", $0c7707a7d12c4d73$export$d11f6c32a9aaae4d);

});
parcelRegister("2IcHK", function(module, exports) {

$parcel$export(module.exports, "TemplateCategorySection", function () { return $b3e024e43a259be9$export$238f728cc1d4638a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $8xSOc = parcelRequire("8xSOc");

var $4VhzM = parcelRequire("4VhzM");
var $b3e024e43a259be9$var$_templateCategorySectionRelayFragment;
const $b3e024e43a259be9$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $b3e024e43a259be9$var$templateCategorySectionStyles = null;
const $b3e024e43a259be9$var$headingStyles = null;
const $b3e024e43a259be9$var$categoryContainerStyles = null;
const $b3e024e43a259be9$var$categoriesRowStylesCfind3646 = null;
const $b3e024e43a259be9$var$categoriesColumnStyles = null;

const $b3e024e43a259be9$var$TemplateCategorySectionRelayFragment = $b3e024e43a259be9$var$_templateCategorySectionRelayFragment !== void 0 ? $b3e024e43a259be9$var$_templateCategorySectionRelayFragment : ($b3e024e43a259be9$var$_templateCategorySectionRelayFragment = (parcelRequire("jgXTd")), $b3e024e43a259be9$var$_templateCategorySectionRelayFragment.hash && $b3e024e43a259be9$var$_templateCategorySectionRelayFragment.hash !== "b09623b07f22b7e206b9416ef23e1799" && console.error("The definition of 'templateCategorySectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $b3e024e43a259be9$var$_templateCategorySectionRelayFragment);
const $b3e024e43a259be9$export$238f728cc1d4638a = ({ template: template, isCfind3646Treatment: isCfind3646Treatment })=>{
    const { categories: categories, templateType: templateType } = (0, $hOqV7.useFragment)($b3e024e43a259be9$var$TemplateCategorySectionRelayFragment, template);
    const intl = (0, $f6qj2.default)();
    const categoryText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.categories.heading",
        defaultMessage: "CATEGORIES"
    });
    const experimentCategories = (categories ?? []).filter((category)=>category.urlSlug === "recommended" || category.urlSlug === "project-management" || category.urlSlug === "software-development-and-it" || category.urlSlug === "product-management" || category.urlSlug === "marketing-and-sales" || category.urlSlug === "design" || category.urlSlug === "finance-and-operations" || category.urlSlug === "human-resources");
    const type = templateType?.[0] ?? {
        id: null,
        templateTypeName: null
    };
    const templateTypeKey = type?.id === $b3e024e43a259be9$var$WHITEBOARD_TEMPLATE_ID ? (0, $4VhzM.TemplateType).Whiteboard : (0, $4VhzM.TemplateType).Page;
    const templateTypeLabel = type?.templateTypeName ?? (0, $4VhzM.TemplateType).Page;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_syaz19tk _1wyboqnp _k48p1nn1 _1dyzt94y _6rth1tcg _1pfh1f4h"
                ]),
                children: categoryText
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    isCfind3646Treatment ? "_1e0c1txw _2lx2vrvc _1n261g80 _zulp1w7n" : "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    experimentCategories.map((category)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c116y _4t3izwfg _85i57vkz"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                                appearance: "inprogress",
                                children: category.name
                            })
                        }, category.id)),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c116y _4t3izwfg _85i57vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                            appearance: templateTypeKey === (0, $4VhzM.TemplateType).Page ? "inprogress" : "success",
                            isBold: true,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "confluence.templates.detail.template.type",
                                defaultMessage: `{templateType} template`,
                                values: {
                                    templateType: templateTypeLabel
                                }
                            })
                        })
                    }, templateTypeKey)
                ]
            })
        ]
    });
};

});
parcelRegister("jgXTd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f1600f9b4bb6413d$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<abb889f860bf8a0d6a6f2f226bfd0403>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f1600f9b4bb6413d$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateCategorySectionRelayFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTaxonomyTemplateType",
                "kind": "LinkedField",
                "name": "templateType",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templateTypeName",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": "categories",
                "args": null,
                "concreteType": "ContentPlatformCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlSlug",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ContentPlatformTemplate",
        "abstractKey": null
    };
}();
$f1600f9b4bb6413d$var$node.hash = "b09623b07f22b7e206b9416ef23e1799";
var $f1600f9b4bb6413d$export$2e2bcd8739ae039 = $f1600f9b4bb6413d$var$node;

});


parcelRegister("9iewL", function(module, exports) {

$parcel$export(module.exports, "TemplateDetailsSection", function () { return $5d9745ba9c6a24ba$export$1a14eb006a5f8a7b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $95kuv = parcelRequire("95kuv");

var $9dbLv = parcelRequire("9dbLv");

var $lXqk8 = parcelRequire("lXqk8");

var $kZboM = parcelRequire("kZboM");

var $6xOgM = parcelRequire("6xOgM");
var $5d9745ba9c6a24ba$var$_templateDetailsSectionRelayFragment;
const $5d9745ba9c6a24ba$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $5d9745ba9c6a24ba$var$templateDetailsSectionStyles = null;
const $5d9745ba9c6a24ba$var$ctaButtonContainerStyles = null;
const $5d9745ba9c6a24ba$var$previewSectionStyles = null;

const $5d9745ba9c6a24ba$var$TemplateDetailsSectionFragment = $5d9745ba9c6a24ba$var$_templateDetailsSectionRelayFragment !== void 0 ? $5d9745ba9c6a24ba$var$_templateDetailsSectionRelayFragment : ($5d9745ba9c6a24ba$var$_templateDetailsSectionRelayFragment = (parcelRequire("6jO4R")), $5d9745ba9c6a24ba$var$_templateDetailsSectionRelayFragment.hash && $5d9745ba9c6a24ba$var$_templateDetailsSectionRelayFragment.hash !== "a0cb459558a181e542607278d1c27860" && console.error("The definition of 'templateDetailsSectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $5d9745ba9c6a24ba$var$_templateDetailsSectionRelayFragment);
const $5d9745ba9c6a24ba$export$1a14eb006a5f8a7b = ({ template: templateRef, isCfind3646Treatment: isCfind3646Treatment })=>{
    const template = (0, $hOqV7.useFragment)($5d9745ba9c6a24ba$var$TemplateDetailsSectionFragment, templateRef);
    const { pluginModuleKey: pluginModuleKey, name: name, templateType: templateType } = template;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const buttonUseTemplateClicked = ()=>{
        openModalForTemplate({
            templateId: pluginModuleKey ?? "",
            templateName: name ?? "",
            productKey: (0, $i8kxh.ProductKeys).CONFLUENCE
        });
    };
    const navigateToSignupClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        buttonUseTemplateClicked();
    };
    const navigateToSignupKeyDown = (event)=>{
        if (event.code === "Space" || event.code === "Enter") {
            event.stopPropagation();
            event.preventDefault();
            buttonUseTemplateClicked();
        }
    };
    const isWhiteBoardTemplate = templateType?.[0]?.id === $5d9745ba9c6a24ba$var$WHITEBOARD_TEMPLATE_ID;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "TemplateDetailsSection",
        className: (0, $esG4f.default)([
            "_tnru1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: isWhiteBoardTemplate ? undefined : navigateToSignupClick,
                onKeyDown: isWhiteBoardTemplate ? undefined : navigateToSignupKeyDown,
                role: "img",
                "aria-label": "Template preview" // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                ,
                tabIndex: 0,
                className: (0, $esG4f.default)([
                    !isWhiteBoardTemplate && "_80omtlke"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lXqk8.TemplatePreview), {
                    template: template,
                    isCfind3646Treatment: isCfind3646Treatment
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9dbLv.TemplateDescription), {
                template: template,
                isCfind3646Treatment: isCfind3646Treatment
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6xOgM.TemplateTabbedSection), {
                template: template,
                isCfind3646Treatment: isCfind3646Treatment
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule _476dvbgk"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $95kuv.TemplateCtaButtons), {
                    name: name ?? "",
                    pluginModuleKey: pluginModuleKey ?? ""
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kZboM.TemplateRelatedTemplates), {
                template: template
            })
        ]
    });
};

});
parcelRegister("9dbLv", function(module, exports) {

$parcel$export(module.exports, "TemplateDescription", function () { return $2090d3350cf3e6c0$export$809977f0794a1530; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $6IiXU = parcelRequire("6IiXU");

var $kQ85F = parcelRequire("kQ85F");

var $bApvB = parcelRequire("bApvB");

var $A9zZc = parcelRequire("A9zZc");
var $2090d3350cf3e6c0$var$_templateDescriptionRelayFragment;
const $2090d3350cf3e6c0$var$truncateTwoLines = null;
const $2090d3350cf3e6c0$var$buttonStyle = null;
const $2090d3350cf3e6c0$var$buttonTextStyle = null;

const $2090d3350cf3e6c0$var$TemplateDescriptionRelayFragment = $2090d3350cf3e6c0$var$_templateDescriptionRelayFragment !== void 0 ? $2090d3350cf3e6c0$var$_templateDescriptionRelayFragment : ($2090d3350cf3e6c0$var$_templateDescriptionRelayFragment = (parcelRequire("g36lg")), $2090d3350cf3e6c0$var$_templateDescriptionRelayFragment.hash && $2090d3350cf3e6c0$var$_templateDescriptionRelayFragment.hash !== "aa0e80feaefdced6bd157a52a501e383" && console.error("The definition of 'templateDescriptionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $2090d3350cf3e6c0$var$_templateDescriptionRelayFragment);
const $2090d3350cf3e6c0$export$809977f0794a1530 = ({ template: template, isCfind3646Treatment: isCfind3646Treatment })=>{
    const { aboutThisTemplate: aboutThisTemplate } = (0, $hOqV7.useFragment)($2090d3350cf3e6c0$var$TemplateDescriptionRelayFragment, template);
    const intl = (0, $f6qj2.default)();
    const [isExpanded, setIsExpanded] = (0, $iSvIT.useState)(false);
    const [isTruncated, setIsTruncated] = (0, $iSvIT.useState)(false);
    const descriptionRef = (0, $iSvIT.useRef)(null);
    const seeMore = intl.formatMessage({
        id: "ConfluenceTemplateDetailsPage.templatesSection.seeMore",
        defaultMessage: "See more"
    });
    const seeLess = intl.formatMessage({
        id: "ConfluenceTemplateDetailsPage.templatesSection.seeLess",
        defaultMessage: "See less"
    });
    (0, $iSvIT.useEffect)(()=>{
        if (descriptionRef.current) {
            const descriptionElement = descriptionRef.current;
            setIsTruncated(descriptionElement.scrollHeight > descriptionElement.clientHeight);
        }
    }, [
        aboutThisTemplate
    ]);
    if (!aboutThisTemplate) return null;
    const renderDescription = ()=>{
        if (isCfind3646Treatment) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    ref: descriptionRef,
                    className: (0, $esG4f.default)([
                        !isExpanded && "_1e0ccj1k _1yyjcs5v _sudp1e54 _1reo15vq _18m915vq"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                        innerHTML: aboutThisTemplate
                    })
                }),
                isTruncated && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bahesu3 _1pfhftgi"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                        appearance: "link",
                        onClick: ()=>setIsExpanded((prev)=>!prev),
                        iconAfter: isExpanded ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bApvB))), {
                            label: "Collapse"
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kQ85F))), {
                            label: "Expand"
                        }),
                        "aria-expanded": isExpanded,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_k48p1nn1"
                            ]),
                            children: isExpanded ? seeLess : seeMore
                        })
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
            innerHTML: aboutThisTemplate
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        "data-testid": "confluence-template-details-template-description",
        children: renderDescription()
    });
};

});
parcelRegister("kQ85F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a026656028c05157ac730015f665601>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2bef0954a3c673e$var$_react = $f2bef0954a3c673e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f2bef0954a3c673e$var$_baseNew = $f2bef0954a3c673e$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $f2bef0954a3c673e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2bef0954a3c673e$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f2bef0954a3c673e$var$_react.default.createElement($f2bef0954a3c673e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.03 3.97 6 7.94l3.97-3.97 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$f2bef0954a3c673e$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $f2bef0954a3c673e$var$_default = module.exports.default = $f2bef0954a3c673e$var$ChevronDownIcon;

});

parcelRegister("bApvB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afcaa915720f5b4d9e69ee6ef0943c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86f6d8062e57451a$var$_react = $86f6d8062e57451a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $86f6d8062e57451a$var$_baseNew = $86f6d8062e57451a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $86f6d8062e57451a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86f6d8062e57451a$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $86f6d8062e57451a$var$_react.default.createElement($86f6d8062e57451a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 4.06 2.03 8.03.97 6.97l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5-1.06 1.06z" clip-rule="evenodd"/>`,
        type: "utility"
    }, props));
$86f6d8062e57451a$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $86f6d8062e57451a$var$_default = module.exports.default = $86f6d8062e57451a$var$ChevronUpIcon;

});

parcelRegister("g36lg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $22a54eb9c6f2898b$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<a269ec7befb799c8019e2b15a7acb5a9>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $22a54eb9c6f2898b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateDescriptionRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aboutThisTemplate",
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplate",
    "abstractKey": null
};
$22a54eb9c6f2898b$var$node.hash = "aa0e80feaefdced6bd157a52a501e383";
var $22a54eb9c6f2898b$export$2e2bcd8739ae039 = $22a54eb9c6f2898b$var$node;

});


parcelRegister("lXqk8", function(module, exports) {

$parcel$export(module.exports, "TemplatePreview", function () { return $39dbaf702194989e$export$48a171bbad47b95a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $1IKTR = parcelRequire("1IKTR");

var $4VhzM = parcelRequire("4VhzM");
var $39dbaf702194989e$var$_templatePreviewRelayFragment;
const $39dbaf702194989e$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $39dbaf702194989e$var$templatePreviewSection = null;
const $39dbaf702194989e$var$templatePreviewSectionCfind3646 = null;
const $39dbaf702194989e$var$previewBackgroundContainer = null;
const $39dbaf702194989e$var$previewBackgroundContainerCfind3646 = null;
const $39dbaf702194989e$var$relativePosition = null;

const $39dbaf702194989e$var$TemplatePreviewRelayFragment = $39dbaf702194989e$var$_templatePreviewRelayFragment !== void 0 ? $39dbaf702194989e$var$_templatePreviewRelayFragment : ($39dbaf702194989e$var$_templatePreviewRelayFragment = (parcelRequire("bpsqg")), $39dbaf702194989e$var$_templatePreviewRelayFragment.hash && $39dbaf702194989e$var$_templatePreviewRelayFragment.hash !== "e15cf739a764eb84e14a1006034c2387" && console.error("The definition of 'templatePreviewRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $39dbaf702194989e$var$_templatePreviewRelayFragment);
const $39dbaf702194989e$export$48a171bbad47b95a = ({ template: template, isCfind3646Treatment: isCfind3646Treatment })=>{
    const { name: name, templateType: templateType, templatePreviews: templatePreviews } = (0, $hOqV7.useFragment)($39dbaf702194989e$var$TemplatePreviewRelayFragment, template);
    const templatePreview = templatePreviews?.[0] ?? null;
    if (!templatePreview) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            isCfind3646Treatment ? "_y3gn1h6o" : "_85i57vkz _y3gn1h6o"
        ]),
        children: templatePreview && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                isCfind3646Treatment ? "_kqswh2mm _85i51tcg _y4tigktf _bozggktf" : "_kqswh2mm _85i5ckbl _y4tigktf _bozggktf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _mnhno812 _9ha51oh5 _3s7lz8o0 _zl7jzoqa"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IKTR.TemplatePreviewWindow), {
                    url: templatePreview.url,
                    alt: "",
                    templateType: templateType?.[0]?.id === $39dbaf702194989e$var$WHITEBOARD_TEMPLATE_ID ? (0, $4VhzM.TemplateType).Whiteboard : (0, $4VhzM.TemplateType).Page
                })
            })
        })
    });
};

});
parcelRegister("bpsqg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $255bf4e95189aa10$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<884436a8e785d5809a558714a86cf90c>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $255bf4e95189aa10$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templatePreviewRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTaxonomyTemplateType",
            "kind": "LinkedField",
            "name": "templateType",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": "templatePreviews",
            "args": null,
            "concreteType": "ContentPlatformTemplateImageAsset",
            "kind": "LinkedField",
            "name": "templatePreview",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplate",
    "abstractKey": null
};
$255bf4e95189aa10$var$node.hash = "e15cf739a764eb84e14a1006034c2387";
var $255bf4e95189aa10$export$2e2bcd8739ae039 = $255bf4e95189aa10$var$node;

});


parcelRegister("kZboM", function(module, exports) {

$parcel$export(module.exports, "TemplateRelatedTemplates", function () { return $442d8eda4438540f$export$7e056a1cce206233; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $3JcvX = parcelRequire("3JcvX");
var $442d8eda4438540f$var$_templateRelatedTemplatesRelayFragment;
const $442d8eda4438540f$var$tabbedSectionHeading = null;
const $442d8eda4438540f$var$relatedTemplatesStyles = null;
const $442d8eda4438540f$var$relatedTemplatesMobileStyles = null;
const $442d8eda4438540f$var$relatedSectionStyles = null;
const $442d8eda4438540f$var$buttonLeft = null;
const $442d8eda4438540f$var$buttonRight = null;
const $442d8eda4438540f$var$buttonLeftArrow = null;
const $442d8eda4438540f$var$buttonRightArrow = null;
const $442d8eda4438540f$var$LeftArrow = ({ onClick: onClick, label: label })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        "aria-label": label,
        className: (0, $esG4f.default)([
            "_bfhku67f _1e0c1ule _vchhusvi _1e02idpf _152t1ssb _1bsbzwfg _4t3izwfg _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_t9eczk8b _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbqmyb0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz"
            ])
        })
    });
const $442d8eda4438540f$var$RightArrow = ({ onClick: onClick, label: label })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        "aria-label": label,
        className: (0, $esG4f.default)([
            "_bfhku67f _vchhusvi _1e0c1ule _rjxpidpf _152t1ssb _1bsbzwfg _4t3izwfg _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_t9ec1hke _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbq1bs0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz"
            ])
        })
    });

const $442d8eda4438540f$var$TemplateRelatedTemplatesRelayFragment = $442d8eda4438540f$var$_templateRelatedTemplatesRelayFragment !== void 0 ? $442d8eda4438540f$var$_templateRelatedTemplatesRelayFragment : ($442d8eda4438540f$var$_templateRelatedTemplatesRelayFragment = (parcelRequire("69Bqc")), $442d8eda4438540f$var$_templateRelatedTemplatesRelayFragment.hash && $442d8eda4438540f$var$_templateRelatedTemplatesRelayFragment.hash !== "826c8adfd1c7809b66dd0577af98a2dc" && console.error("The definition of 'templateRelatedTemplatesRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $442d8eda4438540f$var$_templateRelatedTemplatesRelayFragment);
const $442d8eda4438540f$export$7e056a1cce206233 = ({ template: template })=>{
    const { relatedTemplates: relatedTemplates } = (0, $hOqV7.useFragment)($442d8eda4438540f$var$TemplateRelatedTemplatesRelayFragment, template);
    const intl = (0, $f6qj2.default)();
    const previousLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselPreviousLabel);
    const nextLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselNextLabel);
    const [currentIndex, setCurrentIndex] = (0, $iSvIT.useState)(0);
    const hasRelatedTemplates = relatedTemplates && relatedTemplates.length > 0;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh68cl _ahbq1wug _12l21wug _1ccqvbgk"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    ...(0, $1XyNv.ConfluenceTemplateMessages).relatedTemplatesTitle
                })
            }),
            hasRelatedTemplates && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _7ve31txw _oazgzwfg"
                        ]),
                        children: [
                            currentIndex !== 0 && /*#__PURE__*/ (0, $loA2J.jsx)($442d8eda4438540f$var$LeftArrow, {
                                label: previousLabel,
                                onClick: ()=>{
                                    setCurrentIndex((prevIndex)=>(prevIndex - 1 + relatedTemplates.length) % relatedTemplates.length);
                                }
                            }),
                            relatedTemplates.slice(currentIndex, currentIndex + 2).map((relatedTemplate)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3JcvX.TemplateCard), {
                                        template: relatedTemplate
                                    })
                                }, relatedTemplate.templateId)),
                            currentIndex + 2 < relatedTemplates.length && /*#__PURE__*/ (0, $loA2J.jsx)($442d8eda4438540f$var$RightArrow, {
                                label: nextLabel,
                                onClick: ()=>{
                                    setCurrentIndex((prevIndex)=>(prevIndex + 1) % relatedTemplates?.length);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c1txw _1n261g80 _zulpzwfg _7ve3glyw"
                        ]),
                        children: relatedTemplates.map((relatedTemplate)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3JcvX.TemplateCard), {
                                    template: relatedTemplate
                                })
                            }, relatedTemplate.templateId))
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("69Bqc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $594237f6234fb595$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<3205d98ae8beae3dcda3953d3813cfb1>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $594237f6234fb595$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateRelatedTemplatesRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplate",
            "kind": "LinkedField",
            "name": "relatedTemplates",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateId",
                    "storageKey": null
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "templateCardRelayFragment"
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplate",
    "abstractKey": null
};
$594237f6234fb595$var$node.hash = "826c8adfd1c7809b66dd0577af98a2dc";
var $594237f6234fb595$export$2e2bcd8739ae039 = $594237f6234fb595$var$node;

});


parcelRegister("6xOgM", function(module, exports) {

$parcel$export(module.exports, "TemplateTabbedSection", function () { return $b9c9833ad0b78427$export$c76d52df442babb1; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $cutM5 = parcelRequire("cutM5");

var $A9zZc = parcelRequire("A9zZc");

var $cRwVc = parcelRequire("cRwVc");

var $lfuKW = parcelRequire("lfuKW");

var $BqANR = parcelRequire("BqANR");
var $b9c9833ad0b78427$var$_templateTabbedSectionRelayFragment;
const $b9c9833ad0b78427$var$tabStyles = null;
const $b9c9833ad0b78427$var$tabStylesCfind3646 = null;
const $b9c9833ad0b78427$var$currentStyle = null;
const $b9c9833ad0b78427$var$currentStyleCfind3646 = null;
const $b9c9833ad0b78427$var$tabSectionStyle = null;
const $b9c9833ad0b78427$var$sectionStyles = null;
const $b9c9833ad0b78427$var$sectionStylesCfind3646 = null;
const $b9c9833ad0b78427$var$styles = null;
const $b9c9833ad0b78427$var$TabHeading = ({ title: title, isSelected: isSelected, isEnrolled: isEnrolled })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            isEnrolled ? "_bfhk150w _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1yt41ois _2rko17td _80omtlke _19itzv82 _1wybf6fq _bfw78djs _irr31ybm _30l317la" : "_bfhk17fj _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _ca0qftgi _u5f31tcg _n3tdftgi _19bv1tcg _2rko1tcg _80omtlke _19it1hmt _1wybf6fq _bfw71tdf _irr31t97 _30l3vb1l",
            isEnrolled && isSelected && "_19it8djs _bfhk1ybm _syaz17la",
            !isEnrolled && isSelected && "_19it1tdf _bfhk1t97 _syazvb1l",
            "h5"
        ]),
        style: {
            "--_8nj8hf": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light200")),
            "--_514je1": (0, $43MIc.default)((0, $cRwVc.default)("corner.radius.pill")),
            "--_1r6llbg": (0, $43MIc.default)((0, $cRwVc.default)("color.primary.blue")),
            "--_1hkddbi": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.blue100"))
        },
        children: title
    });
};

const $b9c9833ad0b78427$var$TemplateTabbedSectionRelayFragment = $b9c9833ad0b78427$var$_templateTabbedSectionRelayFragment !== void 0 ? $b9c9833ad0b78427$var$_templateTabbedSectionRelayFragment : ($b9c9833ad0b78427$var$_templateTabbedSectionRelayFragment = (parcelRequire("10Up9")), $b9c9833ad0b78427$var$_templateTabbedSectionRelayFragment.hash && $b9c9833ad0b78427$var$_templateTabbedSectionRelayFragment.hash !== "b2893f87aa786b55bda7e5cc59a7c618" && console.error("The definition of 'templateTabbedSectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $b9c9833ad0b78427$var$_templateTabbedSectionRelayFragment);
const $b9c9833ad0b78427$export$c76d52df442babb1 = ({ template: templateRef, isCfind3646Treatment: isCfind3646Treatment })=>{
    const intl = (0, $f6qj2.default)();
    const template = (0, $hOqV7.useFragment)($b9c9833ad0b78427$var$TemplateTabbedSectionRelayFragment, templateRef);
    const tabs = [
        {
            id: "tab1",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.overview.cfind.1508",
                defaultMessage: "Overview"
            }),
            hide: !template.templateOverview,
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                className: (0, $esG4f.default)([
                    "_1pfh8vuz"
                ]),
                children: template.templateOverview?.map((overview, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                                ]),
                                children: overview.overviewTitle
                            }),
                            overview.overviewDescription && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                                innerHTML: overview.overviewDescription
                            })
                        ]
                    }, `overview-${index}`))
            })
        },
        {
            id: "tab2",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.benefits.cfind.1508",
                defaultMessage: "Benefits"
            }),
            hide: !template.templateBenefits || template.templateBenefits.length === 0,
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                children: template.templateBenefits?.map((templateBenefitsContainer, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $lfuKW.TemplateBenefits), {
                        templateBenefits: templateBenefitsContainer
                    }, `benefits-${index}`))
            })
        },
        {
            id: "tab3",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.howTo.cfind.1508",
                defaultMessage: "How to"
            }),
            hide: !template.howToUseThisTemplate || template.howToUseThisTemplate.length === 0,
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                children: template.howToUseThisTemplate?.map((templateGuide, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $BqANR.TemplateGuide), {
                        templateGuide: templateGuide
                    }, `how2use-${index}`))
            })
        },
        {
            id: "tab4",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.whyConfluence.cfind.1508",
                defaultMessage: "Why Confluence?"
            }),
            // temporary content for demoing... will be replaced with content from template object
            hide: !template.templateProductRationale,
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                className: (0, $esG4f.default)([
                    "_1pfh8vuz"
                ]),
                children: template.templateProductRationale?.map((rationale, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                                ]),
                                children: rationale.rationaleTitle
                            }),
                            rationale.templateProductRationaleDescription && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                                innerHTML: rationale.templateProductRationaleDescription
                            })
                        ]
                    }, `rationale-${index}`))
            })
        }
    ];
    const tabsCfind3646 = [
        tabs[3],
        tabs[0],
        tabs[1],
        tabs[2]
    ];
    const renderTabbedSection = ()=>{
        if (isCfind3646Treatment) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _e8gh1h6o"
                    ]),
                    children: tabsCfind3646.filter((tab)=>!tab?.hide).map((tab)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                            title: tab?.title,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($b9c9833ad0b78427$var$TabHeading, {
                                title: tab?.title,
                                isEnrolled: isCfind3646Treatment
                            })
                        }, tab?.id))
                }),
                tabsCfind3646.filter((tab)=>!tab?.hide).map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                        keepInDom: true,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                            children: tab?.component
                        })
                    }, index))
            ]
        });
        else return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _e8gh1h6o"
                    ]),
                    children: tabs.filter((tab)=>!tab.hide).map((tab)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                            title: tab.title,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($b9c9833ad0b78427$var$TabHeading, {
                                title: tab.title
                            })
                        }, tab.id))
                }),
                tabs.filter((tab)=>!tab.hide).map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                        keepInDom: true,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                            children: tab.component
                        })
                    }, index))
            ]
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        "data-testid": "template-tabbed-section",
        className: (0, $esG4f.default)([
            isCfind3646Treatment ? "_syaz1tj6 _1q51zwfg _1bsb1osq _1e0c1txw _2lx21bp4 _1o8315zi _98bk15zi _1rfm1osq" : "_syaz1tj6 _1q51vbgk _1bsb1osq _1e0c1txw _2lx21bp4 _1o8315zi _98bk15zi _1rfm1osq"
        ]),
        style: {
            "--_1tgiy09": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.blue900"))
        },
        children: renderTabbedSection()
    });
};

});
parcelRegister("lfuKW", function(module, exports) {

$parcel$export(module.exports, "TemplateBenefits", function () { return $12b540f79a5fb375$export$c51d82a2312a377b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $A9zZc = parcelRequire("A9zZc");
var $12b540f79a5fb375$var$_templateBenefitsRelayFragment;
const $12b540f79a5fb375$var$tabbedSectionStyle = null;
const $12b540f79a5fb375$var$stepContainerStyle = null;
const $12b540f79a5fb375$var$tabbedSectionHeading = null;
const $12b540f79a5fb375$var$stepHeading = null;
const $12b540f79a5fb375$var$stepContentWrapper = null;
const $12b540f79a5fb375$var$TemplateBenefitsStep = ({ name: name, shortDescription: shortDescription })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _85i51wto _6rth1wto _179r87ef _zulpviql _1sag1bp4 _qw09glyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulpviql _11yr1k8s"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                    className: (0, $esG4f.default)([
                        "_1wyb1k8s _vwz4viql _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqs1k92 _1bys1k8s"
                    ]),
                    children: name
                }),
                shortDescription && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                    innerHTML: shortDescription
                })
            ]
        })
    });
};

const $12b540f79a5fb375$var$TemplateBenefitsRelayFragment = $12b540f79a5fb375$var$_templateBenefitsRelayFragment !== void 0 ? $12b540f79a5fb375$var$_templateBenefitsRelayFragment : ($12b540f79a5fb375$var$_templateBenefitsRelayFragment = (parcelRequire("7w5TX")), $12b540f79a5fb375$var$_templateBenefitsRelayFragment.hash && $12b540f79a5fb375$var$_templateBenefitsRelayFragment.hash !== "03f54e9ec2683f64ee7161793286e53a" && console.error("The definition of 'templateBenefitsRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $12b540f79a5fb375$var$_templateBenefitsRelayFragment);
const $12b540f79a5fb375$export$c51d82a2312a377b = ({ templateBenefits: templateBenefits })=>{
    const { benefitsTitle: benefitsTitle, templateBenefitContainer: templateBenefitContainer } = (0, $hOqV7.useFragment)($12b540f79a5fb375$var$TemplateBenefitsRelayFragment, templateBenefits);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh8vuz _ahbq1wug _12l21wug _mnhn1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: benefitsTitle
            }),
            templateBenefitContainer?.map((benefitDetail, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($12b540f79a5fb375$var$TemplateBenefitsStep, {
                    name: benefitDetail.name,
                    shortDescription: benefitDetail.shortDescription
                }, `benefit-${index}`))
        ]
    });
};

});
parcelRegister("7w5TX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d3acce3bdba78b2e$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<b649c02d3aeb97214ef9895c713ab998>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d3acce3bdba78b2e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateBenefitsRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "benefitsTitle",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateBenefit",
            "kind": "LinkedField",
            "name": "templateBenefitContainer",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shortDescription",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplateBenefitContainer",
    "abstractKey": null
};
$d3acce3bdba78b2e$var$node.hash = "03f54e9ec2683f64ee7161793286e53a";
var $d3acce3bdba78b2e$export$2e2bcd8739ae039 = $d3acce3bdba78b2e$var$node;

});


parcelRegister("BqANR", function(module, exports) {

$parcel$export(module.exports, "TemplateGuide", function () { return $76cca1c107770d7c$export$a0154bb39f3a2a91; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $A9zZc = parcelRequire("A9zZc");

var $lHB9W = parcelRequire("lHB9W");
var $76cca1c107770d7c$var$_templateGuideRelayFragment;
const $76cca1c107770d7c$var$stepContainerStyle = null;
const $76cca1c107770d7c$var$guideSectionHeading = null;
const $76cca1c107770d7c$var$stepHeading = null;
const $76cca1c107770d7c$var$stepContentWrapper = null;
const $76cca1c107770d7c$var$stepImageWrapper = null;
const $76cca1c107770d7c$var$stepImageStyle = null;
const $76cca1c107770d7c$var$TemplateDetailStep = ({ step: step })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _85i51wto _6rth1wto _179r87ef _zulpviql _1sag1bp4 _qw09glyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulpviql _11yr1k8s"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_1wyb1k8s _vwz4viql _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqs1k92 _1bys1k8s"
                        ]),
                        children: step.name
                    }),
                    step.description && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                        innerHTML: step.description
                    })
                ]
            }),
            step.asset && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_16jlidpf _1o9zidpf _69fu1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    src: step.asset?.url,
                    alt: step.name ?? "",
                    className: (0, $esG4f.default)([
                        "_p12fsb0t _i0i01yk2 _mnhno812"
                    ])
                })
            })
        ]
    });
};

const $76cca1c107770d7c$var$TemplateGuideRelayFragment = $76cca1c107770d7c$var$_templateGuideRelayFragment !== void 0 ? $76cca1c107770d7c$var$_templateGuideRelayFragment : ($76cca1c107770d7c$var$_templateGuideRelayFragment = (parcelRequire("1t810")), $76cca1c107770d7c$var$_templateGuideRelayFragment.hash && $76cca1c107770d7c$var$_templateGuideRelayFragment.hash !== "8f191225e1f7fbeaa8da5aab976af219" && console.error("The definition of 'templateGuideRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $76cca1c107770d7c$var$_templateGuideRelayFragment);
const $76cca1c107770d7c$export$a0154bb39f3a2a91 = ({ templateGuide: templateGuide })=>{
    const { name: name, steps: steps } = (0, $hOqV7.useFragment)($76cca1c107770d7c$var$TemplateGuideRelayFragment, templateGuide);
    const guideName = (0, $lHB9W.expectContent)(name, "Template guide name not found");
    const guideSectionStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh8vuz _ahbq1wug _12l21wug _49yfidpf _hfixidpf _mnhn1osq _i0i0z8o0"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: guideName
            }),
            steps?.map((step, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($76cca1c107770d7c$var$TemplateDetailStep, {
                    step: step
                }, `step-${index}`))
        ]
    });
};

});
parcelRegister("1t810", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $eef814a945e288ba$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<220866b91d51b7e6a63652cdb346ba4a>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eef814a945e288ba$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateGuideRelayFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplateUseStep",
                "kind": "LinkedField",
                "name": "steps",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformTemplateImageAsset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ContentPlatformTemplateGuide",
        "abstractKey": null
    };
}();
$eef814a945e288ba$var$node.hash = "8f191225e1f7fbeaa8da5aab976af219";
var $eef814a945e288ba$export$2e2bcd8739ae039 = $eef814a945e288ba$var$node;

});


parcelRegister("10Up9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $50df3af2a103f420$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<1b42c03b90e0acfededa44d4b676cad5>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $50df3af2a103f420$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateTabbedSectionRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateOverview",
            "kind": "LinkedField",
            "name": "templateOverview",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "overviewTitle",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "overviewDescription",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateBenefitContainer",
            "kind": "LinkedField",
            "name": "templateBenefits",
            "plural": true,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "templateBenefitsRelayFragment"
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateGuide",
            "kind": "LinkedField",
            "name": "howToUseThisTemplate",
            "plural": true,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "templateGuideRelayFragment"
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateProductRationale",
            "kind": "LinkedField",
            "name": "templateProductRationale",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rationaleTitle",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateProductRationaleDescription",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplate",
    "abstractKey": null
};
$50df3af2a103f420$var$node.hash = "b2893f87aa786b55bda7e5cc59a7c618";
var $50df3af2a103f420$export$2e2bcd8739ae039 = $50df3af2a103f420$var$node;

});


parcelRegister("6jO4R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4c5770ba00325a89$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<99f4e0a1a98451ea3a6d8bd434514f11>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c5770ba00325a89$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateDetailsSectionRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pluginModuleKey",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTaxonomyTemplateType",
            "kind": "LinkedField",
            "name": "templateType",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateTypeName",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templatePreviewRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateDescriptionRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateTabbedSectionRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateRelatedTemplatesRelayFragment"
        }
    ],
    "type": "ContentPlatformTemplate",
    "abstractKey": null
};
$4c5770ba00325a89$var$node.hash = "a0cb459558a181e542607278d1c27860";
var $4c5770ba00325a89$export$2e2bcd8739ae039 = $4c5770ba00325a89$var$node;

});


parcelRegister("ib2Qr", function(module, exports) {

$parcel$export(module.exports, "TemplateHeaderSection", function () { return $fd94b27123dc2626$export$8e42656558633420; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $5ohHq = parcelRequire("5ohHq");

var $1fkI6 = parcelRequire("1fkI6");

var $95kuv = parcelRequire("95kuv");

var $iuHDY = parcelRequire("iuHDY");
var $fd94b27123dc2626$var$_templateHeaderSectionRelayFragment;
const $fd94b27123dc2626$var$headerSectionStyles = null;
const $fd94b27123dc2626$var$headerSectionStylesCfind3646 = null;
const $fd94b27123dc2626$var$titleStyles = null;
const $fd94b27123dc2626$var$titleStylesCfind3646 = null;
const $fd94b27123dc2626$var$subTitleStyles = null;
const $fd94b27123dc2626$var$subTitleStylesCfind3646 = null;

const $fd94b27123dc2626$var$TemplateHeaderSectionRelayFragment = $fd94b27123dc2626$var$_templateHeaderSectionRelayFragment !== void 0 ? $fd94b27123dc2626$var$_templateHeaderSectionRelayFragment : ($fd94b27123dc2626$var$_templateHeaderSectionRelayFragment = (parcelRequire("lJXIe")), $fd94b27123dc2626$var$_templateHeaderSectionRelayFragment.hash && $fd94b27123dc2626$var$_templateHeaderSectionRelayFragment.hash !== "91eb2df9d084ed2c556436f9b6a32106" && console.error("The definition of 'templateHeaderSectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $fd94b27123dc2626$var$_templateHeaderSectionRelayFragment);
const $fd94b27123dc2626$export$8e42656558633420 = ({ template: templateRef, isCfind3646Treatment: isCfind3646Treatment })=>{
    const template = (0, $hOqV7.useFragment)($fd94b27123dc2626$var$TemplateHeaderSectionRelayFragment, templateRef);
    const { name: name, oneLinerHeadline: oneLinerHeadline, pluginModuleKey: pluginModuleKey } = template;
    const intl = (0, $f6qj2.default)();
    const templateName = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).templateTitle, {
        templateName: name ?? ""
    });
    const renderCtaButons = ()=>{
        if (isCfind3646Treatment) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1fkI6.default), {
            pluginModuleKey: template.pluginModuleKey || ""
        });
        else return /*#__PURE__*/ (0, $loA2J.jsx)((0, $95kuv.TemplateCtaButtons), {
            name: templateName,
            pluginModuleKey: pluginModuleKey || ""
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        "data-testid": "TemplateHeaderSection",
        className: (0, $esG4f.default)([
            isCfind3646Treatment ? "_1ezz1f7l _1e0c1txw _2lx21bp4 _85i51tcg _ag851h6o" : "_12ornqa1 _1r62t94y _1ezz1f7l _1e0c1txw _2lx21bp4 _85i51tcg _ag851h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    isCfind3646Treatment ? "_syazvejh _ect4kipj _1wyb1ex1 _zg8l4jg8 _k48p9y44 _vwz41wqb _6rth7vkz _1pfhidpf _1i4q1hna _xsmr1h6o" : "_syazalr3 _ect4kipj _1wyb1ex1 _zg8l4jg8 _k48pbfng _vwz41wqb _6rth7vkz _1pfhidpf _1i4q1hna _xsmr1h6o"
                ]),
                style: {
                    "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
                },
                children: templateName
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $iuHDY.TemplateAuthor), {
                template: template,
                isCfind3646Treatment: isCfind3646Treatment
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    isCfind3646Treatment ? "_syazvejh _ect48q0o _1wybgktf _zg8l4jg8 _k48p1nn1 _vwz41f4h _1pfhidpf _xsmr1h6o" : "_syazalr3 _ect48q0o _1wybgktf _zg8l4jg8 _k48p1nn1 _vwz41f4h _6rthzwfg _1pfhidpf _xsmr1h6o"
                ]),
                style: {
                    "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
                },
                children: oneLinerHeadline
            }),
            renderCtaButons()
        ]
    });
};

});
parcelRegister("iuHDY", function(module, exports) {

$parcel$export(module.exports, "TemplateAuthor", function () { return $a6cff3eca6b63e47$export$f6f32ceede8fcfff; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $cRwVc = parcelRequire("cRwVc");
var $a6cff3eca6b63e47$var$_templateAuthorRelayFragment;
const $a6cff3eca6b63e47$var$templateAuthor = null;
const $a6cff3eca6b63e47$var$templateAuthorCfind3646 = null;
const $a6cff3eca6b63e47$var$isAuthor = (contributor)=>contributor?.__typename === "ContentPlatformAuthor";
const $a6cff3eca6b63e47$var$isOrganization = (contributor)=>contributor?.__typename === "ContentPlatformOrganization";

const $a6cff3eca6b63e47$var$TemplateAuthorRelayFragment = $a6cff3eca6b63e47$var$_templateAuthorRelayFragment !== void 0 ? $a6cff3eca6b63e47$var$_templateAuthorRelayFragment : ($a6cff3eca6b63e47$var$_templateAuthorRelayFragment = (parcelRequire("34a9Q")), $a6cff3eca6b63e47$var$_templateAuthorRelayFragment.hash && $a6cff3eca6b63e47$var$_templateAuthorRelayFragment.hash !== "d3e74586e4b920a27abe98ecbb767f31" && console.error("The definition of 'templateAuthorRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $a6cff3eca6b63e47$var$_templateAuthorRelayFragment);
const $a6cff3eca6b63e47$export$f6f32ceede8fcfff = ({ template: template, isCfind3646Treatment: isCfind3646Treatment })=>{
    const { contributor: contributor } = (0, $hOqV7.useFragment)($a6cff3eca6b63e47$var$TemplateAuthorRelayFragment, template);
    let contributorName = ($a6cff3eca6b63e47$var$isAuthor(contributor) || $a6cff3eca6b63e47$var$isOrganization(contributor)) && contributor.name || undefined;
    const author = $a6cff3eca6b63e47$var$isAuthor(contributor) ? contributor : null;
    let authorDetail = author?.jobTitle;
    if (authorDetail && author?.organization?.name) authorDetail = `${authorDetail} @ ${author.organization.name}`;
    if (authorDetail) contributorName = `${contributorName}, (${authorDetail})`;
    return contributorName && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
        className: (0, $esG4f.default)([
            isCfind3646Treatment ? "_1wyboqnp _vwz41neg _1dyzt94y _k48pbfng _syaz1hap _ect41pz4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1tcg _1p1dangw" : "_1wyboqnp _vwz41neg _k48pbfng _syazrbzz _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1tcg _1p1dangw"
        ]),
        style: {
            "--_k3797e": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light700")),
            "--_1h6bnby": (0, $43MIc.default)((0, $cRwVc.default)("font.charlie.display"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            ...(0, $1XyNv.ConfluenceTemplateMessages).templateAuthorByLine,
            values: {
                author: contributorName
            }
        })
    });
};

});
parcelRegister("34a9Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $68adbe0463f7f6c3$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<365054cfbb828b5c28ba02ef519e1bcf>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $68adbe0463f7f6c3$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v1 = [
        v0 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateAuthorRelayFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contributor",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "jobTitle",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentPlatformOrganization",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": v1 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "type": "ContentPlatformAuthor",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v1 /*: any*/ ,
                        "type": "ContentPlatformOrganization",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ContentPlatformTemplate",
        "abstractKey": null
    };
}();
$68adbe0463f7f6c3$var$node.hash = "d3e74586e4b920a27abe98ecbb767f31";
var $68adbe0463f7f6c3$export$2e2bcd8739ae039 = $68adbe0463f7f6c3$var$node;

});


parcelRegister("lJXIe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $69a77ad4c079c355$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<fde90c3b472887aafa408f3d64872c2f>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $69a77ad4c079c355$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateHeaderSectionRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oneLinerHeadline",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pluginModuleKey",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateAuthorRelayFragment"
        }
    ],
    "type": "ContentPlatformTemplate",
    "abstractKey": null
};
$69a77ad4c079c355$var$node.hash = "91eb2df9d084ed2c556436f9b6a32106";
var $69a77ad4c079c355$export$2e2bcd8739ae039 = $69a77ad4c079c355$var$node;

});


parcelRegister("9aBob", function(module, exports) {

$parcel$export(module.exports, "TemplateKeyFeaturesSection", function () { return $075911e8a6c15304$export$b2854e9c3155c1cd; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $l2OTr = parcelRequire("l2OTr");
var $075911e8a6c15304$var$_templateKeyFeaturesSectionRelayFragment;
const $075911e8a6c15304$var$keyFeaturesStyles = null;
const $075911e8a6c15304$var$headingStyles = null;
const $075911e8a6c15304$var$featureStyles = null;
const $075911e8a6c15304$var$featureTextStyles = null;

const $075911e8a6c15304$var$TemplateKeyFeaturesSectionFragment = $075911e8a6c15304$var$_templateKeyFeaturesSectionRelayFragment !== void 0 ? $075911e8a6c15304$var$_templateKeyFeaturesSectionRelayFragment : ($075911e8a6c15304$var$_templateKeyFeaturesSectionRelayFragment = (parcelRequire("anW4F")), $075911e8a6c15304$var$_templateKeyFeaturesSectionRelayFragment.hash && $075911e8a6c15304$var$_templateKeyFeaturesSectionRelayFragment.hash !== "ca513b85820bd9e40ad8bee5602e1221" && console.error("The definition of 'templateKeyFeaturesSectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $075911e8a6c15304$var$_templateKeyFeaturesSectionRelayFragment); // TODO: will get features from template
const $075911e8a6c15304$export$b2854e9c3155c1cd = ({ template: template, isCfind3646Treatment: isCfind3646Treatment })=>{
    const { keyFeatures: keyFeatures } = (0, $hOqV7.useFragment)($075911e8a6c15304$var$TemplateKeyFeaturesSectionFragment, template);
    const intl = (0, $f6qj2.default)(); // TODO: temp placeholder data for UI purposes
    const features = keyFeatures ?? [];
    const headingText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.keyFeatures.heading",
        defaultMessage: "KEY FEATURES"
    });
    return !!features.length && /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            !isCfind3646Treatment && "_1q51zwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                className: (0, $esG4f.default)([
                    "_syaz19tk _1wyboqnp _k48p1nn1 _1dyzt94y _6rthftgi"
                ]),
                children: headingText
            }),
            features.filter((feature)=>feature.name != null).map((feature)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _syazalr3 _1e0c1txw _4t3i1ylp _1q51ftgi"
                    ]),
                    children: [
                        (0, $l2OTr.getIcon)(feature.name ?? ""),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_ahbqdlk8"
                            ]),
                            children: feature.name
                        })
                    ]
                }, feature.name))
        ]
    });
};
var $075911e8a6c15304$export$2e2bcd8739ae039 = $075911e8a6c15304$export$b2854e9c3155c1cd;

});
parcelRegister("anW4F", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ed9e5eb19e5ff972$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<056a479a4ed1d8e6497dc8d606e08078>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed9e5eb19e5ff972$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateKeyFeaturesSectionRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTaxonomyFeature",
            "kind": "LinkedField",
            "name": "keyFeatures",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplate",
    "abstractKey": null
};
$ed9e5eb19e5ff972$var$node.hash = "ca513b85820bd9e40ad8bee5602e1221";
var $ed9e5eb19e5ff972$export$2e2bcd8739ae039 = $ed9e5eb19e5ff972$var$node;

});


parcelRegister("9PXzP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $752a08bcc31c8077$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<813d06408ec53c27bc0c0a176014c454>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $752a08bcc31c8077$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "urlSlug"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        },
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "fieldNamed",
                                                    "value": "urlSlug"
                                                },
                                                {
                                                    "items": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "havingValues.0",
                                                            "variableName": "urlSlug"
                                                        }
                                                    ],
                                                    "kind": "ListValue",
                                                    "name": "havingValues"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "exactlyMatching"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "searchText"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "where"
                        },
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "withLocales.0",
                                    "variableName": "locale"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "withLocales"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "queries"
                }
            ],
            "kind": "ObjectValue",
            "name": "search"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "templateId",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pluginModuleKey",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v6 = [
        v3 /*: any*/ 
    ], v7 = {
        "alias": null,
        "args": null,
        "concreteType": "ContentPlatformOrganization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": null
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "ContentPlatformOrganization",
        "abstractKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "concreteType": "ContentPlatformTaxonomyTemplateType",
        "kind": "LinkedField",
        "name": "templateType",
        "plural": true,
        "selections": [
            v9 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateTypeName",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v12 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "confluenceTemplateDetailsRelayPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v1 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templates",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplateResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTemplate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "templateHeaderSectionRelayFragment"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "templateKeyFeaturesSectionRelayFragment"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "templateCategorySectionRelayFragment"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "templateDetailsSectionRelayFragment"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluenceTemplateDetailsRelayPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v1 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templates",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplateResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTemplate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "oneLinerHeadline",
                                            "storageKey": null
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "contributor",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "jobTitle",
                                                            "storageKey": null
                                                        },
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "ContentPlatformAuthor",
                                                    "abstractKey": null
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTaxonomyFeature",
                                            "kind": "LinkedField",
                                            "name": "keyFeatures",
                                            "plural": true,
                                            "selections": v6 /*: any*/ ,
                                            "storageKey": null
                                        },
                                        v10 /*: any*/ ,
                                        {
                                            "alias": "categories",
                                            "args": null,
                                            "concreteType": "ContentPlatformCategory",
                                            "kind": "LinkedField",
                                            "name": "category",
                                            "plural": true,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": "templatePreviews",
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateImageAsset",
                                            "kind": "LinkedField",
                                            "name": "templatePreview",
                                            "plural": true,
                                            "selections": v12 /*: any*/ ,
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "aboutThisTemplate",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateOverview",
                                            "kind": "LinkedField",
                                            "name": "templateOverview",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "overviewTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "overviewDescription",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateBenefitContainer",
                                            "kind": "LinkedField",
                                            "name": "templateBenefits",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "benefitsTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentPlatformTemplateBenefit",
                                                    "kind": "LinkedField",
                                                    "name": "templateBenefitContainer",
                                                    "plural": true,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "shortDescription",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateGuide",
                                            "kind": "LinkedField",
                                            "name": "howToUseThisTemplate",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentPlatformTemplateUseStep",
                                                    "kind": "LinkedField",
                                                    "name": "steps",
                                                    "plural": true,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "description",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentPlatformTemplateImageAsset",
                                                            "kind": "LinkedField",
                                                            "name": "asset",
                                                            "plural": false,
                                                            "selections": v12 /*: any*/ ,
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateProductRationale",
                                            "kind": "LinkedField",
                                            "name": "templateProductRationale",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "rationaleTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "templateProductRationaleDescription",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplate",
                                            "kind": "LinkedField",
                                            "name": "relatedTemplates",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "previewBlurb",
                                                    "storageKey": null
                                                },
                                                v10 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "contributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ 
                                                            ],
                                                            "type": "ContentPlatformAuthor",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "df8f7e8d2fadfb0178ce017fedf07603",
            "id": null,
            "metadata": {},
            "name": "confluenceTemplateDetailsRelayPageQuery",
            "operationKind": "query",
            "text": 'query confluenceTemplateDetailsRelayPageQuery(\n  $locale: String!\n  $urlSlug: String!\n) {\n  templates(search: {queries: {first: 1, withLocales: [$locale], where: {searchText: {exactlyMatching: {fieldNamed: "urlSlug", havingValues: [$urlSlug]}}}}}) {\n    edges {\n      node {\n        templateId\n        ...templateHeaderSectionRelayFragment\n        ...templateKeyFeaturesSectionRelayFragment\n        ...templateCategorySectionRelayFragment\n        ...templateDetailsSectionRelayFragment\n        name\n        pluginModuleKey\n      }\n    }\n  }\n}\n\nfragment templateAuthorRelayFragment on ContentPlatformTemplate {\n  contributor {\n    __typename\n    ... on ContentPlatformAuthor {\n      name\n      jobTitle\n      organization {\n        name\n      }\n    }\n    ... on ContentPlatformOrganization {\n      name\n    }\n  }\n}\n\nfragment templateBenefitsRelayFragment on ContentPlatformTemplateBenefitContainer {\n  benefitsTitle\n  templateBenefitContainer {\n    name\n    shortDescription\n  }\n}\n\nfragment templateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  name\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateType {\n    id\n    templateTypeName\n  }\n  contributor {\n    __typename\n    ... on ContentPlatformOrganization {\n      name\n    }\n    ... on ContentPlatformAuthor {\n      organization {\n        name\n      }\n    }\n  }\n}\n\nfragment templateCategorySectionRelayFragment on ContentPlatformTemplate {\n  templateType {\n    id\n    templateTypeName\n  }\n  categories: category {\n    id\n    name\n    urlSlug\n  }\n}\n\nfragment templateDescriptionRelayFragment on ContentPlatformTemplate {\n  aboutThisTemplate\n}\n\nfragment templateDetailsSectionRelayFragment on ContentPlatformTemplate {\n  name\n  pluginModuleKey\n  templateType {\n    id\n    templateTypeName\n  }\n  ...templatePreviewRelayFragment\n  ...templateDescriptionRelayFragment\n  ...templateTabbedSectionRelayFragment\n  ...templateRelatedTemplatesRelayFragment\n}\n\nfragment templateGuideRelayFragment on ContentPlatformTemplateGuide {\n  name\n  steps {\n    name\n    description\n    asset {\n      url\n    }\n  }\n}\n\nfragment templateHeaderSectionRelayFragment on ContentPlatformTemplate {\n  name\n  oneLinerHeadline\n  pluginModuleKey\n  ...templateAuthorRelayFragment\n}\n\nfragment templateKeyFeaturesSectionRelayFragment on ContentPlatformTemplate {\n  keyFeatures {\n    name\n  }\n}\n\nfragment templatePreviewRelayFragment on ContentPlatformTemplate {\n  name\n  templateType {\n    id\n  }\n  templatePreviews: templatePreview {\n    url\n  }\n}\n\nfragment templateRelatedTemplatesRelayFragment on ContentPlatformTemplate {\n  relatedTemplates {\n    templateId\n    ...templateCardRelayFragment\n  }\n}\n\nfragment templateTabbedSectionRelayFragment on ContentPlatformTemplate {\n  templateOverview {\n    overviewTitle\n    overviewDescription\n  }\n  templateBenefits {\n    ...templateBenefitsRelayFragment\n  }\n  howToUseThisTemplate {\n    ...templateGuideRelayFragment\n  }\n  templateProductRationale {\n    rationaleTitle\n    templateProductRationaleDescription\n  }\n}\n'
        }
    };
}();
$752a08bcc31c8077$var$node.hash = "978aa2c3ffdfcc73a88a375ca658ddbf";
var $752a08bcc31c8077$export$2e2bcd8739ae039 = $752a08bcc31c8077$var$node;

});



parcelRegister("iHyWi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9d7585a20730163$var$_react = $d9d7585a20730163$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d9d7585a20730163$var$_success = $d9d7585a20730163$var$_interopRequireDefault((parcelRequire("bPtgt")));
function $d9d7585a20730163$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9d7585a20730163$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $d9d7585a20730163$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d9d7585a20730163$var$_success.default
    }));
$d9d7585a20730163$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $d9d7585a20730163$var$_default = module.exports.default = $d9d7585a20730163$var$CheckCircleIcon;

});
parcelRegister("bPtgt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8a54e77ebc6c63c295a0cd7c7e0eeda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89cb2877c2082d69$var$_react = $89cb2877c2082d69$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $89cb2877c2082d69$var$_baseNew = $89cb2877c2082d69$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $89cb2877c2082d69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89cb2877c2082d69$var$SuccessIcon = (props)=>/*#__PURE__*/ $89cb2877c2082d69$var$_react.default.createElement($89cb2877c2082d69$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$89cb2877c2082d69$var$SuccessIcon.displayName = "SuccessIcon";
var $89cb2877c2082d69$var$_default = module.exports.default = $89cb2877c2082d69$var$SuccessIcon;

});


parcelRegister("ctYD4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9167392384132023$var$_react = $9167392384132023$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9167392384132023$var$_baseNew = $9167392384132023$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9167392384132023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9167392384132023$var$CommentIcon = (props)=>/*#__PURE__*/ $9167392384132023$var$_react.default.createElement($9167392384132023$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$9167392384132023$var$CommentIcon.displayName = "CommentIcon";
var $9167392384132023$var$_default = module.exports.default = $9167392384132023$var$CommentIcon;

});

parcelRegister("jwsof", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e367072653dd9624$var$_react = $e367072653dd9624$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e367072653dd9624$var$_baseNew = $e367072653dd9624$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e367072653dd9624$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e367072653dd9624$var$FileIcon = (props)=>/*#__PURE__*/ $e367072653dd9624$var$_react.default.createElement($e367072653dd9624$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e367072653dd9624$var$FileIcon.displayName = "FileIcon";
var $e367072653dd9624$var$_default = module.exports.default = $e367072653dd9624$var$FileIcon;

});

parcelRegister("llWxg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8b8f712153f66c5$var$_react = $f8b8f712153f66c5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f8b8f712153f66c5$var$_baseNew = $f8b8f712153f66c5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $f8b8f712153f66c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8b8f712153f66c5$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f8b8f712153f66c5$var$_react.default.createElement($f8b8f712153f66c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$f8b8f712153f66c5$var$FeedbackIcon.displayName = "FeedbackIcon";
var $f8b8f712153f66c5$var$_default = module.exports.default = $f8b8f712153f66c5$var$FeedbackIcon;

});

parcelRegister("30lzE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23021b54e58d1b56$var$_react = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $23021b54e58d1b56$var$_baseNew = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $23021b54e58d1b56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23021b54e58d1b56$var$RoadmapIcon = (props)=>/*#__PURE__*/ $23021b54e58d1b56$var$_react.default.createElement($23021b54e58d1b56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$23021b54e58d1b56$var$RoadmapIcon.displayName = "RoadmapIcon";
var $23021b54e58d1b56$var$_default = module.exports.default = $23021b54e58d1b56$var$RoadmapIcon;

});

parcelRegister("8A4p1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63f519c8ab72f6bb$var$_react = $63f519c8ab72f6bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $63f519c8ab72f6bb$var$_feedback = $63f519c8ab72f6bb$var$_interopRequireDefault((parcelRequire("llWxg")));
function $63f519c8ab72f6bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $63f519c8ab72f6bb$var$FeedbackIcon = (props)=>/*#__PURE__*/ $63f519c8ab72f6bb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $63f519c8ab72f6bb$var$_feedback.default
    }));
$63f519c8ab72f6bb$var$FeedbackIcon.displayName = "FeedbackIcon";
var $63f519c8ab72f6bb$var$_default = module.exports.default = $63f519c8ab72f6bb$var$FeedbackIcon;

});

parcelRegister("aOabo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7de678fbce1024bb$var$_react = $7de678fbce1024bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $7de678fbce1024bb$var$_roadmap = $7de678fbce1024bb$var$_interopRequireDefault((parcelRequire("30lzE")));
function $7de678fbce1024bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7de678fbce1024bb$var$RoadmapIcon = (props)=>/*#__PURE__*/ $7de678fbce1024bb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $7de678fbce1024bb$var$_roadmap.default
    }));
$7de678fbce1024bb$var$RoadmapIcon.displayName = "RoadmapIcon";
var $7de678fbce1024bb$var$_default = module.exports.default = $7de678fbce1024bb$var$RoadmapIcon;

});

parcelRegister("ixaDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7e38ffb7694e997$var$_react = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d7e38ffb7694e997$var$_refresh = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("5sfxx")));
function $d7e38ffb7694e997$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d7e38ffb7694e997$var$RefreshIcon = (props)=>/*#__PURE__*/ $d7e38ffb7694e997$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $d7e38ffb7694e997$var$_refresh.default
    }));
$d7e38ffb7694e997$var$RefreshIcon.displayName = "RefreshIcon";
var $d7e38ffb7694e997$var$_default = module.exports.default = $d7e38ffb7694e997$var$RefreshIcon;

});
parcelRegister("5sfxx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f8b9f2e6d41a4e8$var$_react = $3f8b9f2e6d41a4e8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3f8b9f2e6d41a4e8$var$_baseNew = $3f8b9f2e6d41a4e8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3f8b9f2e6d41a4e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f8b9f2e6d41a4e8$var$RefreshIcon = (props)=>/*#__PURE__*/ $3f8b9f2e6d41a4e8$var$_react.default.createElement($3f8b9f2e6d41a4e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$3f8b9f2e6d41a4e8$var$RefreshIcon.displayName = "RefreshIcon";
var $3f8b9f2e6d41a4e8$var$_default = module.exports.default = $3f8b9f2e6d41a4e8$var$RefreshIcon;

});


parcelRegister("5XRUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04422a31fe921661fd3c15a462bdcae0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $457c47c57a91dbf4$var$_react = $457c47c57a91dbf4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $457c47c57a91dbf4$var$_baseNew = $457c47c57a91dbf4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $457c47c57a91dbf4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $457c47c57a91dbf4$var$GlobeIcon = (props)=>/*#__PURE__*/ $457c47c57a91dbf4$var$_react.default.createElement($457c47c57a91dbf4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$457c47c57a91dbf4$var$GlobeIcon.displayName = "GlobeIcon";
var $457c47c57a91dbf4$var$_default = module.exports.default = $457c47c57a91dbf4$var$GlobeIcon;

});

parcelRegister("3uaOm", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $4da674d0ece1632c$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $4da674d0ece1632c$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    socialSignUpButtonContinueWithGoogle: {
        id: `WacSignupForm.socialSignUpButtonContinueWithGoogle`,
        defaultMessage: "Continue with Google"
    },
    socialSignUpButtonContinueWithMicrosoft: {
        id: `WacSignupForm.socialSignUpButtonContinueWithMicrosoft`,
        defaultMessage: "Continue with Microsoft"
    },
    socialSignUpButtonSignUpWithEmail: {
        id: `WacSignupForm.socialSignUpButtonSignUpWithEmail`,
        defaultMessage: "Sign up with email"
    },
    socialSignUpButtonSignUpWithGoogle: {
        id: `WacSignupForm.socialSignUpButtonSignUpWithGoogle`,
        defaultMessage: "Sign up with Google"
    }
});

});


var $2A2ZL = parcelRequire("2A2ZL");

var $bRUWA = parcelRequire("bRUWA");

var $hCxil = parcelRequire("hCxil");
(0, $2A2ZL.init)((0, $bRUWA.ConfluenceTemplateDetailsRelayPage), (0, $hCxil.ConfluenceTemplateDetailsRelayPageQuery), (0, $hCxil.getConfluenceTemplateDetailsRelayPageQueryVars)(window.location));


//# sourceMappingURL=confluence-template-details-relay-page.dda40e04.js.map
